/**
 * The lab-panel snapshot inside a logic (LogicBuilder/GetAll → labPanels[])
 * carries the panel's *internal* name in `name` — "<name>.<panel guid>",
 * e.g. "1 Panel with questions.535b9e3d-2b67-08df-0000-000000000000" — while
 * every other panel object keeps that in `internalname` and the plain name in
 * `name`. Until the backend aligns them, strip a trailing ".<guid>" for display.
 */
const INTERNAL_SUFFIX =
  /\.[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const displayLabPanelName = (
  name: string | null | undefined,
  fallback = "Lab Panel"
): string => {
  const trimmed = (name ?? "").trim();
  if (!trimmed) return fallback;
  return trimmed.replace(INTERNAL_SUFFIX, "") || fallback;
};
